var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTradeNames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 27h2v2h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17 27h30v2h-30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13 33h2v2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17 33h30v2h-30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13 39h2v2h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17 39h30v2h-30z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m16 12a4 4 0 0 0 -4-4h-4v13h2v-5h1.382l2.723 5.447 1.79-.894-2.421-4.842a4 4 0 0 0 2.526-3.711zm-4 2h-2v-4h2a2 2 0 0 1 0 4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m24.136 8.496-2.636 4.519-2.636-4.519-1.728 1.008 3.206 5.496-3.206 5.496 1.728 1.008 2.636-4.519 2.636 4.519 1.728-1.008-3.206-5.496 3.206-5.496z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m45.414 2h-43.414v55.425l5.149 4.964 4.149-4 4.148 4 4.142-4 4.143 4 4.144-4 4.143 4 4.144-4 4.141 4 4.14-4 4.143 4 4.138-4 4.141 4 5.135-4.965v-38.838zm.586 3.414 12.586 12.586h-12.586zm10.864 54.2-4.14-4-4.139 4-4.142-4-4.14 4-4.141-4-4.144 4-4.143-4-4.144 4-4.143-4-4.143 4-4.146-4-4.15 4-3.149-3.039v-52.575h40v16h16v36.576z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m32 50h24v2h-24z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeNames);
export default __webpack_public_path__ + "static/media/TradeNames.eadfb449.svg";
export { ForwardRef as ReactComponent };